module.exports = __webpack_public_path__ + "media/components/images/panels/4-a-e317763332f5f3db03e0d208e189b702.jpeg";